import { useState, useCallback } from "react";

export type AccountModalMode = "view" | "edit";

/**
 * Hook for managing AccountModal state
 * Handles modal open/close, account selection, and edit mode toggling
 */
export const useAccountModalState = () => {
    const [open, setOpen] = useState(false);
    const [accountId, setAccountId] = useState<string>("");
    const [portfolioId, setPortfolioId] = useState<string | null>(null);
    const [mode, setMode] = useState<AccountModalMode>("view");

    const openModal = useCallback((accId: string, portId: string | null) => {
        setAccountId(accId);
        setPortfolioId(portId);
        setMode("view");
        setOpen(true);
    }, []);

    const closeModal = useCallback(() => {
        setOpen(false);
        setAccountId("");
        setPortfolioId(null);
        setMode("view");
    }, []);

    const toggleEditMode = useCallback(() => {
        setMode((prevMode) => (prevMode === "view" ? "edit" : "view"));
    }, []);

    return {
        open,
        accountId,
        portfolioId,
        mode,
        openModal,
        closeModal,
        toggleEditMode,
    };
};
